import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { PATHS } from 'constants';

import { Col, Row } from 'react-bootstrap';
import LeftNav from 'components/default/LeftNav';
import Ship from './Ship';
import Flight from './Flight';
import LRUFaults from './LRUFaults';
import LRUDetail from './LRUDetail';
import Usage from './Usage';
import Availability from './Availability';
import ConfigurableFeatures from './ConfigurableFeatures';

import styles from './styles.module.css';

const Reports = (props) => {
  const {
    match: { params, path },
    rActiveFlight,
    rAircraftList,
    rFlightList,
    push,
  } = props;

  const NavMap = {
    Create: [
      {
        display: 'Ship',
        id: 'ship',
      },
      {
        display: 'Flight',
        id: 'flight',
      },
      {
        display: 'LRUs & Faults',
        id: 'lrusFaults',
      },
      {
        display: 'LRU Details',
        id: 'lruDetails',
      },
      {
        display: 'Usage',
        id: 'usage',
      },
      {
        display: 'Compact faults',
        id: 'availability',
      },
      {
        display: 'Config features',
        id: 'configurableFeatures',
      },
    ],
  };

  const defaultPage = 'ship';

  const pathParams = path?.split('/');
  const selectedReport = pathParams[2] ? pathParams[2] : defaultPage;
  const id = params?.id;

  const renderMenuItem = () => {
    switch (selectedReport) {
      case 'flight':
        return (
          <Flight
            aircraftList={rAircraftList}
            flightList={rFlightList}
            activeFlight={rActiveFlight}
            flightId={id}
          />
        );
      case 'lrusFaults':
        return <LRUFaults />;
      case 'lruDetails':
        return <LRUDetail aircraftList={rAircraftList} LruId={id} />;
      case 'usage':
        return (
          <Usage
            aircraftList={rAircraftList}
            activeFlight={rActiveFlight}
            flightId={id}
          />
        );
      case 'availability':
        return <Availability />;
      case 'configurableFeatures':
        return <ConfigurableFeatures />;
      case 'ship':
      default:
        return <Ship aircraftList={rAircraftList} aircraftId={id} />;
    }
  };

  return (
    <Row className={styles.root} data-cy-id="Reports" noGutters>
      <Col md="auto" className={styles.leftPanel}>
        <LeftNav
          activeMenuItem={!selectedReport ? 'availability' : selectedReport}
          changeActiveMenu={(id) => {
            push(`${PATHS.reports}/${id}`);
          }}
          navMap={NavMap}
          primaryHeader="Reports"
          testIdPrefix="Reports"
        />
      </Col>
      <Col className={styles.container}>{renderMenuItem()}</Col>
    </Row>
  );
};

const state = (state) => {
  return {
    rAircraftList: state.aircraftList,
    rFlightList: state.flightList,
    rActiveFlight: state.activeFlight,
  };
};

const actions = {
  push,
};

export default connect(state, actions)(Reports);
